<script setup lang="ts">
import { $message } from '@nio-fe/lego';
import MicroDrawer from '@/components/micro-drawer/index';
import MicroDrawerV2 from '@/components/micro-drawer-v2/index';
import { inject, onMounted, ref } from 'vue';

const messageHandler = inject('messageHandler');
const drawerPropsRef = ref(`
  {
    "appName": "test-drive/test-drive-create",
    "drawerProps": {
      "unfold": true,
    },
  }
`);

const link = '/wk-form#/object-form?page_id=595abaa5-8ed4-4fea-b51a-aa9a313a682e&object_id=m_obj_6658988908454150146&pk_value=f027';
let instanceRef;
const drawerIframeProps = {
  path: `/iframe-container${link}`,
  version: 2,
  drawerProps: {
    unfold: true,
    disableSecondaryButton: true,
    disablePrimaryButton: true,
    showCloseBtn: true,
    width: 480,
    title: '我是标题我是标题我是标题我是标题我是标题我是标题',

    onPreRow: (options) => {
      console.log('onPreRow');
      instanceRef.api.setPreRowDisable(true);
      instanceRef.api.setNextRowDisable(false);
      options.path = 'iframe-container/wk-form#/object-form?page_id=595abaa5-8ed4-4fea-b51a-aa9a313a682e&object_id=m_obj_6658988908454150146&pk_value=f027'
      return options;
    },
    onNextRow: (options) => {
      console.log('onNextRow');
      instanceRef.api.setPreRowDisable(false);
      instanceRef.api.setNextRowDisable(true);
      options.path = 'iframe-container/wk-form#/object-form?page_id=595abaa5-8ed4-4fea-b51a-aa9a313a682e&object_id=m_obj_6658988908454150146&pk_value=f037'
      return options;
    },
    onDrawerReady: (instance) => {
      console.log('instance: ', instance);
      instanceRef = instance;
      instanceRef.api.setPreRowDisable(true);
      instanceRef.api.setNextRowDisable(false);
    },
  },
  openAsIframe: true,
};


onMounted(() => {
  if (localStorage.getItem('demoDrawerProps')) {
    drawerPropsRef.value = localStorage.getItem('demoDrawerProps') || '';
  }
});

const handleOpenDrawer = () => {
  try {
    const data = JSON.parse(drawerPropsRef.value);
    localStorage.setItem('demoDrawerProps', drawerPropsRef.value);
    MicroDrawer.open(data);
  } catch (e) {
    $message.error('请输入正确的JSON格式');
  }
};
const onDragStart = () => {
  return function (event: DragEvent) {
    console.log(event);
  };
};

const onDragEnd = () => {
  console.log('onDragEnd');
};

const handleOpenDrawerIframe = () => {
  MicroDrawerV2.open(drawerIframeProps)
};

</script>

<template>
  <div class="container">
    <div class="function">
      <h3>LOAD Drawer</h3>
      <n-input
        type="textarea"
        v-model="drawerPropsRef"
        placeholder="请输入drawerOpen参数"
        :rows="10"
      ></n-input>
      <p style="margin-top: 20px">
        <n-button @click="handleOpenDrawer">打开Drawer</n-button>
      </p>
    </div>
    <div class="function">
      <h3>Load Message</h3>
      <n-button
        @click="
          $message.success({
            message: '显示测试消息！！！',
            duration: 60 * 1000,
          })
        "
      >打开消息</n-button
      >
    </div>
    <div class="function">
      <h3>原生拖动功能测试</h3>
      <n-button
        :ondragstart="onDragStart()"
        :ondragend="onDragEnd"
        :draggable="true"
      >原生拖动功能测试</n-button
      >
    </div>
    <div class="function">
      <h3>LOAD Drawer v2</h3>
      <p style="margin-top: 20px">
        <n-button @click="handleOpenDrawerIframe">打开Drawer(Iframe)</n-button>
      </p>
    </div>
  </div>
</template>

<style scoped lang="scss">
.container {
  padding: 20px;
  p {
    margin: 0 0 10px 0;
  }
}
.function {
  margin-bottom: 20px;
  padding: 20px;
  border: 1px solid #dadada;
}
</style>
